import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import FddContract from '../src'

import './assets/css/common.scss'

import App from './App.vue'
import router from './router'

// 启用开发工具
Vue.config.devtools = true

/** 依赖：懒加载组件 */
Vue.use(VueLazyload, {
  attempt: 1,
  observer: true
})

/** 依赖：ElementUI */
Vue.use(ElementUI, { size: 'mini' })

/** 安装合同控件 */
Vue.use(FddContract)

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
